import { gql } from "@apollo/client";

const GET_NOT_SELECTED_APPLICATION_REASONS = gql`
  query GetNotSelectedApplicationReasons($filters: TagFilter) {
    notSelectedApplicationReasons(filters: $filters) {
      nodes {
        name
        id
      }
    }
  }
`;

export { GET_NOT_SELECTED_APPLICATION_REASONS };
